module.exports = "<% var notifs = [] %>\n<% var notification = notificationCollection.findWhere({[property]: mod.get(\"id\")}) %>\n<% notification.get('enable_email_notifications') ?  notifs.push('Email') : '' %>\n<% notification.get('enable_sms_notifications') ?  notifs.push('Text') : '' %>\n<div class=\"col-md-5 col-sm-5 col-xs-12\"><%- notifs.join(', ') %></div>\n";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/templates/account/team/notificationDetailsOverview.html
// module id = 757
// module chunks = 7